import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NoteEditorModalComponent } from '../../../../note-editor-modal/note-editor-modal.component';
import { FileDisplayComponent } from '../../file-display.component';
import { DisplayableFile } from '../../../interfaces/displayable-file.interface';

@Component({
  selector: '[app-file-display-with-modal]',
  templateUrl: './file-display-with-modal.component.html',
  styleUrls: [
    './../../file-display.component.scss',
    './file-display-with-modal.component.scss'
  ],
  standalone: false
})
export class FileDisplayWithModalComponent extends FileDisplayComponent {

  constructor(private dialog: MatDialog) {
    super();
  }

  handleViewEditNote(isFileSubmitted: boolean = false): void {
    const dialogRef = this.dialog.open(NoteEditorModalComponent, {
      data: { 
        note: this.displayableFileObj?.documentDescription || '',
        wasSubmitted: isFileSubmitted
      },
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== undefined) {
        this.displayableFileObj!.documentDescription = result;
      }
    })
  }

  ngOnInit(): void {
    super.ngOnInit(); // is this line necessary? or will it run th eonInit twice?
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
  
  /** Used for ternary operation to (1) determine if it exists and (2) determines validity */
  customValidForUploadLogic(): { exists: boolean; value: boolean } {
    return { exists: true, value: true};
  }
  
  preUploadSingleFileBehavior() {
   // add custom validation
  }

}
